import http from "../../../utils/services/http-client";

class AdminPanelService {
  getAdminPanelProduct() {
    return http.get(`/DraftProducts` );
  }
  productApprove(model:any) {
    return http.put(`/Approve` ,model);
  }
  productReject(model:any) {
    return http.put(`/Reject` ,model);
  }
}

export default new AdminPanelService();
